// src/components/relatorios/TabelaPerformance.js
import React from 'react';

function TabelaPerformance({ data }) {
  if (!data || data.length === 0) {
    return <div className="tabela-vazia">Nenhum dado disponível</div>;
  }

  const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    }).format(valor || 0);
  };

  // Ordenar por valor faturado (decrescente)
  const dadosOrdenados = [...data].sort((a, b) => 
    parseFloat(b.valor_faturado) - parseFloat(a.valor_faturado)
  );

  return (
    <div className="tabela-performance">
      <table className="tabela-relatorio">
        <thead>
          <tr>
            <th className="col-ranking">#</th>
            <th className="col-tecnico">Técnico</th>
            <th className="col-numero">Total OS</th>
            <th className="col-numero">OS Faturadas</th>
            <th className="col-valor">Valor Faturado</th>
            <th className="col-valor">Ticket Médio</th>
            <th className="col-percentual">Taxa Conversão</th>
          </tr>
        </thead>
        <tbody>
          {dadosOrdenados.map((tecnico, index) => {
            const valorFaturado = parseFloat(tecnico.valor_faturado);
            const ticketMedio = parseFloat(tecnico.ticket_medio);
            const taxaConversao = parseFloat(tecnico.taxa_conversao);

            // Destaque para o melhor
            const isTop = index === 0;

            return (
              <tr key={index} className={isTop ? 'linha-destaque' : ''}>
                <td className="col-ranking">
                  {index === 0 && <span className="medalha">🥇</span>}
                  {index === 1 && <span className="medalha">🥈</span>}
                  {index === 2 && <span className="medalha">🥉</span>}
                  {index > 2 && <span>{index + 1}º</span>}
                </td>
                <td className="col-tecnico">
                  <strong>{tecnico.tecnico_nome}</strong>
                </td>
                <td className="col-numero">{tecnico.total_os}</td>
                <td className="col-numero">{tecnico.os_faturadas}</td>
                <td className="col-valor destaque-valor">{formatarValor(valorFaturado)}</td>
                <td className="col-valor">{formatarValor(ticketMedio)}</td>
                <td className="col-percentual">
                  <span className={`badge-conversao ${taxaConversao >= 70 ? 'alta' : taxaConversao >= 40 ? 'media' : 'baixa'}`}>
                    {taxaConversao}%
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr className="linha-total">
            <td colSpan="2"><strong>TOTAL</strong></td>
            <td className="col-numero">
              <strong>{dadosOrdenados.reduce((acc, t) => acc + parseInt(t.total_os), 0)}</strong>
            </td>
            <td className="col-numero">
              <strong>{dadosOrdenados.reduce((acc, t) => acc + parseInt(t.os_faturadas), 0)}</strong>
            </td>
            <td className="col-valor">
              <strong>{formatarValor(dadosOrdenados.reduce((acc, t) => acc + parseFloat(t.valor_faturado), 0))}</strong>
            </td>
            <td colSpan="2"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default TabelaPerformance;
